/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 问卷入口弹窗组件
 * @LastEditors: yingongjing
 * @LastEditTime: 2026-01-09 13:58:24
 */
import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'

import desktopLib from '../../../../../utils/desktopLib'
import './index.scss'
import { CloseOutlined, RightOutlined } from '@ant-design/icons'

interface SurveyModalProps {
  visible: boolean
  onCancel: () => void
  onParticipate: () => void
  surveyUrl?: string
}

const SurveyModal: React.FC<SurveyModalProps> = ({
  visible,
  onCancel,
  onParticipate,
  surveyUrl = 'https://alidocs.dingtalk.com/notable/share/form/v013BMqYybKYzKb6qwZ_hERWDMS_WyPvuh8'
}) => {
  const handleParticipate = () => {
    onParticipate()
    // 打开问卷链接：客户端使用 openContact，Web端使用 window.open
    if (desktopLib.isDesktop) {
      desktopLib.openContact(surveyUrl)
    } else {
      window.open(surveyUrl, '_blank')
    }
    // 关闭弹窗
    onCancel()
  }

  const handleCancel = () => {
    // 记录已关闭，不再弹出
    localStorage.setItem('watermarkBatchEditor_surveyClosed', 'true')
    onCancel()
  }

  // 防止背景滚动
  useEffect(() => {
    if (visible) {
      // 可以在这里添加防止滚动的逻辑，如果需要的话
    }
  }, [visible])

  if (!visible) {
    return null
  }

  const content = (
    <div className="survey-modal-wrapper">
      <div className="survey-modal-content">
        {/* 关闭按钮 */}
        <CloseOutlined className="survey-close-btn" onClick={handleCancel} />
        {/* 头部区域 */}
        <div className="survey-header">
          {/* 图标 */}
          <div className="survey-icon">
            <div className="icon-bg">
              <div className="icon-bubble">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="icon-pencil"
                >
                  <path
                    d="M11.5 2L14.5 5M2.5 10.5L9.5 3.5L12.5 6.5L5.5 13.5H2.5V10.5Z"
                    stroke="#1861ff"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>

          {/* 标题和状态 */}
          <div className="survey-title-section">
            <h2 className="survey-title">批量编辑水印功能体验问卷</h2>
            <div className="survey-status">
              <span className="status-dot"></span>
              <span className="status-text">功能全新上线</span>
            </div>
          </div>
        </div>

        {/* 内容区域 */}
        <div className="survey-body">
          <p className="survey-description">
            感谢您使用今日水印相机管理后台!您的意见对我们优化产品非常重要,完成问卷仅需
            <strong>2</strong>分钟。
          </p>
        </div>

        {/* 操作按钮 */}
        <div className="survey-actions">
          <button className="survey-btn-primary" onClick={handleParticipate}>
            立即参与
            <RightOutlined />
          </button>
          <button className="survey-btn-secondary" onClick={handleCancel}>
            以后再说
          </button>
        </div>
      </div>
    </div>
  )

  return createPortal(content, document.body)
}

export default SurveyModal
